import { Blockquote, Amazon, Series, Instagram, InternalLink } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Blockquote,
  Amazon,
  Series,
  Instagram,
  InternalLink,
  React
};